import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "text-capitalize-first" }
const _hoisted_3 = { class: "text-danger" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = {
  key: 0,
  class: "text-danger text-capitalize-first"
}
const _hoisted_6 = { class: "text-capitalize-first d-inline-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.helper.trans(`antifraudalerts.rule.${_ctx.alert.rule}`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.helper.trans(`antifraudalerts.description.${_ctx.alert.rule}.default`, {count: _ctx.data?.count})), 1)
    ]),
    (_ctx.data?.trafficBlocked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.traffic_blocked')) + " " + _toDisplayString(_ctx.data?.deviceName ? _ctx.helper.trans('labels.device_name', {name: _ctx.data?.deviceName}) : ''), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}